import { render, staticRenderFns } from "./SmartTableWidget.vue?vue&type=template&id=b8f74faa&scoped=true"
import script from "./SmartTableWidget.vue?vue&type=script&lang=js"
export * from "./SmartTableWidget.vue?vue&type=script&lang=js"
import style0 from "./SmartTableWidget.vue?vue&type=style&index=0&id=b8f74faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f74faa",
  null
  
)

export default component.exports